import { Injectable } from '@angular/core';
import { ApiServiceService } from '../../../services/api-service.service';
import { catchError, throwError } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { formatParams } from '../../../helpers/FormateArrayToParams';

@Injectable({
  providedIn: 'root'
})
export class CompaniesService {

  constructor(private _apiService: ApiServiceService) { }

  ListCompanies(model: any) {
    return this._apiService.get(`${environment.apiUrl}/companies`, model)
      .pipe(catchError(this.handleError));
  }
  AddCompany(model: any) {
    return this._apiService.post(`${environment.apiUrl}/companies`, model)
      .pipe(catchError(this.handleError));
  }

  UpdateCompany(model: any, id: string) {
    return this._apiService.post(`${environment.apiUrl}/companies/${id}`, model)
      .pipe(catchError(this.handleError));
  }

  GetCities(model: any) {
    return this._apiService.get(`${environment.apiUrl}/cities`, model)
      .pipe(catchError(this.handleError));
  }

  GetPackages(model: any) {
    return this._apiService.get(`${environment.apiUrl}/packages`, model)
      .pipe(catchError(this.handleError));
  }

  GetPackagesWithoutPermission() {
    return this._apiService.get(`${environment.apiUrl}/packages/list`)
      .pipe(catchError(this.handleError));
  }

  GetWalletTransactions(model: any) {
    let Params = formatParams(model)
    return this._apiService.get(`${environment.apiUrl}/wallet-transactions${Params}`)
      .pipe(catchError(this.handleError));
  }

  GetWithdrawalRequests(model: any) {
    return this._apiService.get(`${environment.apiUrl}/money-withdraw-request`, model)
      .pipe(catchError(this.handleError));
  }

  ApproveWithdrawalRequest(model: any) {
    return this._apiService.post(`${environment.apiUrl}/money-withdraw-request/approve-request`, model)
      .pipe(catchError(this.handleError));
  }

  DeclineWithdrawalRequest(model: any) {
    return this._apiService.post(`${environment.apiUrl}/money-withdraw-request/reject-request`, model)
      .pipe(catchError(this.handleError));
  }

  GetWithdrawalRequestById(id: any) {
    return this._apiService.post(`${environment.apiUrl}/money-withdraw-request/request-details/?request_id=${id}`)
      .pipe(catchError(this.handleError));
  }

  CompaniesSearch(model: any) {
    return this._apiService.get(`${environment.apiUrl}/companies-list-with-search`, model)
      .pipe(catchError(this.handleError));
  }


  // Registeration Requests
  GetRegisterationRequests(model: any) {
    return this._apiService.get(`${environment.apiUrl}/companies-registration-request`, model)
      .pipe(catchError(this.handleError));
  }

  GetRegisterationRequesttById(id: any) {
    return this._apiService.post(`${environment.apiUrl}/companies-registration-request/request-details/?request_id=${id}`)
      .pipe(catchError(this.handleError));
  }

  ApproveRegisterationRequest(model: any) {
    return this._apiService.post(`${environment.apiUrl}/companies-registration-request/approve-request`, model)
      .pipe(catchError(this.handleError));
  }

  DeclineRegisterationRequest(model: any) {
    return this._apiService.post(`${environment.apiUrl}/companies-registration-request/reject-request`, model)
      .pipe(catchError(this.handleError));
  }


  GetRewardedEmployees(model: any) {
    return this._apiService.get(`${environment.apiUrl}/rewarding-points`, model)
      .pipe(catchError(this.handleError));
  }

  GetCompanyDepartements(id: string) {
    return this._apiService.get(`${environment.apiUrl}/rewarding-points/get-company-departments/?reward_id=${id}`)
      .pipe(catchError(this.handleError));
  }

  GetDepartementsEmployees(model: any) {
    return this._apiService.get(`${environment.apiUrl}/rewarding-points`, model)
      .pipe(catchError(this.handleError));
  }


  GetCompanyDepatements(model: any) {
    return this._apiService.get(`${environment.apiUrl}/company-profile/departments`, model)
      .pipe(catchError(this.handleError));
  }

   GetCompanyAllDepatementsDDl(model: any) {
    return this._apiService.get(`${environment.apiUrl}/ddl/departments`, model)
      .pipe(catchError(this.handleError));
  }

  GetCompanyDepartementsWithSearch(model: any) {
    return this._apiService.get(`${environment.apiUrl}/rewarding-points/get-company-departments`, model)
      .pipe(catchError(this.handleError));
  }

  GetCompanyEmployeesWithSearch(model: any) {
    return this._apiService.get(`${environment.apiUrl}/rewarding-points/get-company-departments-users`, model)
      .pipe(catchError(this.handleError));
  }

  RenewSubscription(model: any) {
    return this._apiService.post(`${environment.apiUrl}/companies/renew-subscription`, model)
      .pipe(catchError(this.handleError));
  }


  getDepartements(model: any) {
    return this._apiService.get(`${environment.apiUrl}/departments`, model)
      .pipe(catchError(this.handleError));
  }

  getVacationPolicyList(company_id: string) {
    return this._apiService.get(`${environment.apiUrl}/employees/company-vacation-policy?company_id=${company_id}`)
      .pipe(catchError(this.handleError));
  }

  GetAllowdZonesList(company_id: string) {
    return this._apiService.get(`${environment.apiUrl}/companies/settings/multiple-locations?company_id=${company_id}`)
      .pipe(catchError(this.handleError));
  }
  handleError(error: any) {
    return throwError(error);
  }
}
